import './personalInformation.css';
import React, { Component, Fragment } from 'react';

import PersonIcon from '../Common/Svg/PersonIcon';
import VettingInput from '../Common/VettingInput/VettingInput';
import NewCustomerBack from '../Common/NewCustomerBack/NewCustomerBack';
import SubmitLeadRequestError from "./../Common/SubmitLeadRequestError/SubmitLeadRequestError";

import {
	checkInputValidity,
	addBeforeloadEvent,
	removeBeforeloadEvent,
	getSelectedProductsArrays
} from "./../../Utility/utility";
import { SalesContext } from '../../Context/SalesContext';
import { submitLead } from '../../Services/Services';
import {
	tagOnFinalizeOrderErrorPage,
	tagOnContactInformationPageLoad,
	tagOnFinalizeOrderError,
	tagOnContactInformationDetailsStarted,
	tagOnLeadSubmissionFail,
	tagOnRequestSubmitSuccess
} from "./../../Tagging/SalesTagging";
import PrivacyCheckbox from '../Common/PrivacyCheckbox/PrivacyCheckbox';

class PersonalInformation extends Component {

	static contextType = SalesContext;

	state = {
		formComponents: {
			firstName: {
				name: "*First Name",
				type: "input",
				value: "",
				validations: {
					required: true,
					invalidMessage: "Please enter a valid first name",
					maxLength: 50,
					minLength: 1
				},
				config: {
					type: "text",
					required: true
				},
				isValid: false,
				isTouched: false
			},
			lastName: {
				name: "*Last Name",
				type: "input",
				value: "",
				validations: {
					required: true,
					invalidMessage: "Please enter a valid last name",
					maxLength: 50,
					minLength: 1
				},
				config: {
					required: true
				},
				isValid: false,
				isTouched: false
			},
			email: {
				name: "*Email address",
				type: "input",
				value: "",
				validations: {
					required: true,
					invalidMessage: "Please enter a valid email",
					type: "email"
				},
				config: {
					type: "text",
					required: true
				},
				isValid: false,
				isTouched: false
			},
			contactNumber: {
				name: "*Cellphone number",
				type: "input",
				value: "",
				validations: {
					required: true,
					isPhoneNumber: true,
					invalidMessage: "Please enter a valid contact number",
					minLength: 10,
					type: 'cellphoneNo'
				},
				config: {
					type: "text",
					required: true,
					maxLength: 12
				},
				isValid: false,
				isTouched: false
			}
		},
		isFormValid: false,
		formSubmitAttempt: 0,
		hasError: false,
		isTermsAccepted: false,
		showError: false
	}

	onTermsChange = () => {

		let value = !this.state.isTermsAccepted;

		this.setState({
			isTermsAccepted: value
		})

		if (this.state.showError && value === true) {

			this.setState({
				showError: false
			})
		}
  }

	formComponentChangeHandler = (value, inputIdentifier) => {

		if (inputIdentifier === "firstName" && value.length === 1) {

			tagOnContactInformationDetailsStarted();
		}

		const formCompsCopy = { ...this.state.formComponents };
		const changedComponent = { ...formCompsCopy[inputIdentifier] };
		if (inputIdentifier === 'email' || inputIdentifier === 'contactNumber') {
			changedComponent.value = value.trim();
		}
		else {
			changedComponent.value = value;
		}
		changedComponent.isValid = checkInputValidity(changedComponent.value, changedComponent.validations);
		changedComponent.isTouched = true;

		this.context.setUserDetails({ key: inputIdentifier, value: changedComponent.value });

		const newFormComps = { ...formCompsCopy, [inputIdentifier]: changedComponent }
		this.setState({ formComponents: newFormComps, isFormValid: this.checkFormValidity(newFormComps) });
	}

	checkFormValidity = (form) => form.contactNumber.isValid && form.email.isValid && form.firstName.isValid && form.lastName.isValid;

	submitLeadRequest = () => {

		if (!this.state.isTermsAccepted) {
    
			this.setState({
				showError: true
			})

			return;
		}

		this.context.setShowSpinner(true);

		submitLead(this.context).then(res => {

			this.context.setUserDetails({ key: 'referenceNo', value: res.result.referenceNumber });
			const { taggingIdArray, taggingQtyArray, taggingPriceArray } = getSelectedProductsArrays(this.context.selectedPackage, this.context.selectedAdditionalServices, this.context.additionalServices);
			tagOnRequestSubmitSuccess(
				res.result.referenceNumber,
				'EC Lead success',
				taggingIdArray, 
				taggingQtyArray, 
				taggingPriceArray,
				this.context.isUserExisting,
				this.context.userDetails.contactNumber
			);
			this.props.history.push('/cloud/fibre/sales/success');
			this.context.setShowSpinner(false);
		}).catch(error => {

			if (this.state.formSubmitAttempt <= 4) {

				this.setState(prevState => {

					return {
						hasError: true,
						formSubmitAttempt: prevState.formSubmitAttempt + 1
					}
				});

				tagOnLeadSubmissionFail(error.response.data.message);
			} else {

				this.resetError();
				tagOnFinalizeOrderErrorPage(error.response.data.message);
				this.props.history.push('/cloud/fibre/sales/error');
			}

			this.context.setShowSpinner(false);
		})
	}

	resetError = () => {

		this.setState({
			hasError: false,
			formSubmitAttempt: 0
		});
	}

	errorResubmitClickHandler = () => {

		tagOnFinalizeOrderError();
    
		this.setState(prevState => {

			return {
				hasError: false,
				formSubmitAttempt: prevState.formSubmitAttempt + 1
			}
		});
	}

	componentWillUnmount = () => {

		removeBeforeloadEvent();
	}

	componentDidMount = () => {

		addBeforeloadEvent();
		tagOnContactInformationPageLoad();

		const prevData = this.context.userDetails;
		const formCompsCopy = { ...this.state.formComponents };

		for (let key in prevData) {

			if (prevData[key] === "")
				continue;

			const changedComponent = { ...formCompsCopy[key] };
			changedComponent.value = prevData[key];

			changedComponent.isValid = checkInputValidity(
				changedComponent.value,
				changedComponent.validations
			);

			changedComponent.isTouched = true;

			formCompsCopy[key] = changedComponent;
		}

		const isFormValid = this.checkFormValidity(formCompsCopy);
		this.setState({ formComponents: formCompsCopy, isFormValid: isFormValid });
	}

	render = () => {

		return (
			<Fragment>

				<NewCustomerBack
					title={'Back'}
					backUrl={this.context.leadAdditionalServices?.length >= 1 ? "/cloud/fibre/sales/planDetails" : '/cloud/fibre/sales/deliveryAddress'}
				/>

				<div className='personal-information-container'>

					{ this.state.hasError &&

						<SubmitLeadRequestError
							reSubmit={this.errorResubmitClickHandler}
							close={this.resetError}
							automationidattr={'PersonalInformation'}
						/>
					}

					<div
						className="personalInfo-lead-heading-wrapper"
						automationid='SalesLead_Div_PersonalInformationLeadHeadingContainer_0'
					>

						<div
							className="personalInfo-lead-heading"
							automationid='SalesLead_Div_PersonalInformationLeadHeading_0'
						>
							Thank you!
						</div>

						<div
							className="personalInfo-lead-description"
							automationid='SalesLead_Div_PersonalInformationLeadDescription_0'
						>
							You are one step closer to a better internet solution! Please give us your information and a call centre agent will be in touch.
						</div>

					</div>

					<div className="personalInfo-wrapper">

						<div className="personalInfo-title" automationid={`SalesLead_Div_PersonalInformationHeading_0`}>

							<PersonIcon
								strokeColor={'#333333'}
							/>

							Personal information
						</div>

						<div className="divider" />

						<div className="personalInfo-form-input-row">

							<div className="personalInfo-form-input-column">

								<div className="form-item">

									<div
										className="form-item-label"
										automationid='SalesLead_Div_PersonalInformationFormFirstNameLabel_0'
									>
										First name
									</div>

									<VettingInput
										inputIdentifier="firstName"
										updateValue={this.formComponentChangeHandler}
										{...this.state.formComponents.firstName}
										automationidattr={`FirstName`}
									/>

								</div>

								<div className="form-item-divider" />

								<div className="form-item">

									<div
										className="form-item-label"
										automationid='SalesLead_Div_PersonalInformationFormLastNameLabel_0'
									>
										Last name
									</div>

									<VettingInput
										inputIdentifier="lastName"
										updateValue={this.formComponentChangeHandler}
										{...this.state.formComponents.lastName}
										automationidattr={`LastName`}
									/>

								</div>

							</div>

							<div className="personalInfo-form-input-column">

								<div className="form-item">

									<div
										className="form-item-label"
										automationid='SalesLead_Div_PersonalInformationFormContactNumberLabel_0'
									>
										Cellphone number
									</div>

									<VettingInput
										inputIdentifier="contactNumber"
										updateValue={this.formComponentChangeHandler}
										{...this.state.formComponents.contactNumber}
										automationidattr={`ContactNumber`}
									/>

								</div>

								<div className="form-item-divider" />

								<div className="form-item">

									<div
										className="form-item-label"
										automationid='SalesLead_Div_PersonalInformationFormEmailLabel_0'
									>
										Email address
									</div>

									<VettingInput
										inputIdentifier="email"
										updateValue={this.formComponentChangeHandler}
										{...this.state.formComponents.email}
										automationidattr={`Email`}
									/>

								</div>

							</div>

						</div>

						<div className='personalInfo-privacy-wrapper'>
						<PrivacyCheckbox
							checked={this.state.isTermsAccepted}
							onChange={this.onTermsChange}
							showError={this.state.showError}
						/>
						</div>

						<div className='personalInfo-form-footer'>

							<button
								className="submit-button"
								onClick={this.submitLeadRequest}
								disabled={!this.state.isFormValid}
								automationid={`SalesLead_Button_PersonalInformationSubmit_0`}
							>
								Submit
							</button>

						</div>

					</div>

				</div>

			</Fragment>
		);
	}
}

export default PersonalInformation;